import { SwatchGroup } from "../models/swatch-group";
import { SwatchGroupView } from "./swatch-group";
import { VariationView } from "./variation-view";
import { SubVariationView } from "./sub-variation-view";
import { Swatch } from "../models/swatch";
import { customizerTemplate, subVariationListTemplate } from "../templates";


var Customizer = Backbone.View.extend({
    el: '#product-customizer',
    events: {
        'click a.swatch-link' : 'selectSwatch',
        'click a.variation-link' : 'selectVariation',
        'click a.sub-variation-link' : 'selectSubVariation',
        'click a.dropdown-variations' : 'dropdownVariations',
        'click a.product-collapse-link' : 'storeOptionSection'
    },
    initialize: function(options) {
        this.initialLoad = true;
        this.options = options;
        this.options.open_swatch_section = null;
        this.options.configurator = this.options.product_data.configurator;
        _.bindAll( this, 
            'render', 
            'addVariation', 
            'updateCustomizerProduct', 
            'renderOptionGroups',
            'renderOptionGroup',
            'selectSwatch',
            'selectVariation',
            'storeOptionSection',
            'closeSection',
            'dropdownVariations',
            'addSubVariation',
            'updateCustomizerSubProduct',
            'selectSubVariation',
            'updateCustomizerPhoto'
        );

        this.swatchCounts = {};
        this._views = [];
    },
    render: function(){
        if ( !_.isEmpty( this._views ) ) {
            _.each(this._views, function(view){
                view.trigger( 'teardown' );
                view.remove();
                view.unbind();
            });
            this._views = [];
        }
        var html = customizerTemplate( { productName : this.model.get('name') } );
        this.el.innerHTML = html;
        this.collection.each( this.addVariation );
        if ( this.collection.length < 2 ) {
            this.$('.product-variations a.dropdown-variations').addClass( 'single-variation' );
        }
        
        window.customLogger( this.model.toJSON() );

        // to do
        // add option groups for the current variation
        this.renderOptionGroups();


        
    },
    dropdownVariations: function( e ){
        e.preventDefault();
        if ( e.currentTarget.classList.contains( 'single-variation' ) ) {
            // this section shouldn't toggle, there aren't choices.
            return;
        }
        if ( ! e.currentTarget.parentElement.classList.contains( 'open-parent' ) ) {
            this.$('.open-parent').removeClass( 'open-parent' );
        }
        if ( ! e.currentTarget.parentElement.parentElement.classList.contains( 'open-list' ) ) {
            this.$('.open-list').removeClass( 'open-list' );
        }
        e.currentTarget.parentElement.classList.toggle( 'open-parent' );
        e.currentTarget.parentElement.parentElement.classList.toggle( 'open-list' );
    },
    storeOptionSection: function( e ){
        e.preventDefault();
        
        var type = e.currentTarget.dataset.finish_type;
        if ( this.options.open_swatch_section !== type ) {
            if ( this.options.open_swatch_section !== null ) {
                var currentSection = this.$( '.product-'+this.options.open_swatch_section+'-link' );
                currentSection.parent().removeClass( 'open-parent' );
                this.$( currentSection.data('target') ).collapse('hide');
            }

            this.options.open_swatch_section = type;
            e.currentTarget.parentElement.classList.add( 'open-parent' );
            // e.currentTarget.parentElement.scrollIntoView();
        } else {
            this.options.open_swatch_section = null;
            e.currentTarget.parentElement.classList.remove( 'open-parent' );
        }
    },
    closeSection: function(){
        if ( this.options.open_swatch_section !== null ) {
            var currentSection = this.$( '.product-'+this.options.open_swatch_section+'-link' );
            currentSection.parent().removeClass( 'open-parent' );
            this.$( currentSection.data('target') ).collapse('hide');
            this.options.open_swatch_section = null;
        }
    },
    addVariation: function( variation ){
        // replace this with a backbone subview, on select change the model.
        var x = new VariationView({ model: variation, product: this.model });
        this._views.push( x );
        this.$('ul.variations-list').append( x.el );

        // if this is the active model, we probably need to include sub variations here!
        if ( this.model.get( 'parent_sku' ) == variation.get( 'sku' ) ) {
            if ( variation.get('has_sub_variations') ) {
               
                let mVariation = this.model.get( 'variation' );
                let variationName = typeof mVariation.name !== 'undefined' ? mVariation.name: '';
				// if we are editing an existing configuration, 
				// assume the sub variation label will be set appropriately already
                if ( this.initialLoad && !this.model.get( 'editing' ) ) {
                    this.initialLoad = false;
                    let theSub = variation.get( 'sub_variations' ).at(0);
                    this.model.set({ 'variation' : theSub.toJSON() });
                    variationName = theSub.get('name');
                }
                var subHtml = subVariationListTemplate({ 'name' : variationName });
                this.$('.sub-variations').html(subHtml);
                variation.get('sub_variations').each( this.addSubVariation );
            }
        }
    },
    addSubVariation: function( sub ){

        // replace this with a backbone subview, on select change the model.
        var x = new SubVariationView({ model: sub, product: this.model });
        this._views.push( x );
        this.$('ul.sub-variations-list').append( x.el );
    },
    renderOptionGroups: function( ){
        let variation = this.model.get( 'variation' );
        this.model.set( {'settings_labels' : {}} );
        let optionGroups = variation.options;
        this.swatchCounts = {};
        _.each( optionGroups, this.renderOptionGroup );

        let settings = this.model.get( 'settings'  );
        let settings_labels = this.model.get( 'settings_labels' );
        let newSettings = {};
        for (const c in settings_labels) {
            if ( typeof settings[c] === 'undefined' ) {
                newSettings[c] = '';
            } else {
                newSettings[c] = settings[c];
            }
        }
        this.model.set( { 'settings' : newSettings } );
    },
    renderOptionGroup: function( group ){

        // option group will become a sub view
        let option_slug = group.type.slug;
        let option_type = this.options.product_data.swatch_types[option_slug].finish_type;
        let option_swatches = this.options.product_data.swatch_types[option_slug].swatches;

        if ( typeof this.swatchCounts[option_type] === 'undefined' ) {
            this.swatchCounts[option_type] = 0;
        } else {
            this.swatchCounts[option_type]++;
        }
        var typeKey = parseInt( this.swatchCounts[option_type] ) > 0 ? option_type + '_' + this.swatchCounts[option_type] : option_type;
        // update the options labels to se can show it in the cart.
        var settings_labels = this.model.get( 'settings_labels' );
        settings_labels[typeKey] = group.label;
        this.model.set( {'settings_labels' : settings_labels} );
        
        let swatchGroup = new SwatchGroup({ 'type' : typeKey, 'label':group.label });
        let variation_exclusions = this.model.get( 'variation' ).exclusions;
        let option_exclusions = group.exclusions;
        let exclusions = this.model.get('swatch_exclusions');

        for ( var i = 0; i < option_swatches.length; i++ ) {
            let swatchData = option_swatches[i];
            if ( exclusions.includes( parseInt( swatchData.post_id ) ) ) {
                //console.log( 'excluded at the overall level', swatchData );
                continue;
            } 
            if ( variation_exclusions.includes( parseInt( swatchData.post_id ) ) ) {
                //console.log( 'excluded at the varation level', swatchData );
                continue;
            }
            if ( option_exclusions.includes( parseInt( swatchData.post_id ) ) ) {
                //console.log( 'excluded at the option level', swatchData );
                continue;
            }
            var swatch = new Swatch(swatchData); // option_swatches[i]

            
            swatch.set( 'type', typeKey );
            swatchGroup.get('swatches').push( swatch );
            //this.$('p#group-options-'+option_type).append( swatch.name + ' ' + swatch.code );
            // option swatch with become a sub sub view
        }
        var y = this.model.get( 'settings' );
        if (  typeof y[typeKey] !== 'undefined' ) {
            var theSelection = y[typeKey];
        } 
        var isOpen = this.options.open_swatch_section == typeKey;
        var isOutdoor = parseInt( this.model.get( 'outdoor' ) ) === 1 ? true: false;
        

        var optionGroup = new SwatchGroupView({model: swatchGroup, selection: theSelection, open: isOpen, outdoor : isOutdoor });
        this._views.push( optionGroup );
        this.$('.swatch-groups').append( optionGroup.el );
    },
    updateCustomizerProduct: function( newSku = false ){
        window.customLogger( 'updating', newSku ); 
        var variation = newSku ? this.collection.find({ sku : newSku }) : this.collection.at(0);
        var parentSku = variation.get('sku');
        var newOpts = { 
            'parent_sku': parentSku,
            'name' : variation.get('name')
        }; 
             
        if ( variation.get( 'has_sub_variations' ) ) {
            var firstSub = variation.get( 'sub_variations' ).at( 0 );
            newOpts.variation = firstSub.toJSON(); 
            newOpts.sku = firstSub.get( 'sku' );
            newOpts.image = firstSub.get( 'image' );
        } else {
            newOpts.variation = variation.toJSON(); 
            newOpts.sku = variation.get('sku');
            newOpts.image = variation.get( 'image' );
        }
       

        this.model.set( newOpts ); // maybe update more about the model here...

        window.customLogger( this.model.toJSON() ); 

        if ( this.options.configurator ) {
            window.productConfigurator.selectSku( this.model.get('product_family'), newSku );
        } else {
            // we should change the hero photo here!
            this.updateCustomizerPhoto( newOpts.image );

        }

        this.render();
    },
    updateCustomizerSubProduct: function( newSku ) {
        var parentSku = this.model.get( 'parent_sku' );
        var parentProduct = this.collection.find({ sku : parentSku });
        var subProduct = parentProduct.get( 'sub_variations' ).find({ sku : newSku });
        // var prodSettings = this.model.toJSON();

        this.model.set({ 'variation' : subProduct.toJSON() });
        this.model.set({ 'sku' : newSku });
        this.model.set({ 'image' : subProduct.get( 'image' ) });


        this.$('.sub-product-name').text( subProduct.get( 'name' ) );
        this.$('.variation-selector h3').removeClass( 'open-parent' );
        this.$('.variation-selector').removeClass( 'open-list' );
        this.$('.sub-variations-list').removeClass( 'open-parent' );

        this.$('.swatch-groups').html('');
        this.renderOptionGroups();

        if ( this.options.configurator ) {
            window.productConfigurator.selectSku( this.model.get('product_family'), newSku );
        } else {
            // we should change the hero photo here!
            this.updateCustomizerPhoto( subProduct.get( 'image' ) );

        }
    },
    selectSwatch: function( e ){
        e.preventDefault();
        if ( e.type === 'keypress' && ( e.which !== 13 || e.keyCode !== 13 ) ) {
            return false;
        }
        var swatch = e.currentTarget;
        let name = swatch.dataset.name;
        let code = swatch.dataset.code;
        let type = swatch.dataset.type;

        this.$( '.' + type + '-finish.active' ).removeClass( 'active' );
        swatch.classList.add( 'active');
        
        this.$( '.' + type + '-selection' ).text( name );
        // update model settings, to send to the cart if quote requested.

        var newSettings = this.model.get( 'settings' );
        newSettings[type] = name; // changed this from `code` to be an object with a user label
        this.model.set({ 'settings' : newSettings });
        if ( this.options.configurator ) {
            window.productConfigurator.selectColor( type, code ); // continue to select code here
        }
        this.closeSection();
    },
    selectVariation: function( e ){
        e.preventDefault();
        let skuVal = e.currentTarget.dataset.sku;
        this.updateCustomizerProduct( skuVal );
    },
    selectSubVariation: function( e ){
        e.preventDefault();

        let skuVal = e.currentTarget.dataset.sku;
        this.updateCustomizerSubProduct( skuVal );
    },
    updateCustomizerPhoto : function( url ){
        // console.log( url );
        document.getElementById('customizer-preview-photo').src = url;
        document.getElementById('customizer-preview-photo').srcset = url;
        // imageEl.src = url;
    }
});

export {Customizer};